import { useState, useEffect } from "react";
import Button from "../button/Button";
import styles from "./MonthFilter.module.scss";

interface MonthOption {
	value: string;
	label: string;
	date: Date;
}

interface MonthFilterProps {
	isOpen: boolean;
	onClose: () => void;
	onApply: (monthValue: string) => void;
	initialMonth: string;
	monthOptions: MonthOption[];
}

export const MonthFilter = ({
	isOpen,
	onClose,
	onApply,
	initialMonth,
	monthOptions,
}: MonthFilterProps) => {
	const [selectedMonth, setSelectedMonth] = useState<string>(initialMonth);

	useEffect(() => {
		if (isOpen) {
			setSelectedMonth(initialMonth);
		}
	}, [isOpen, initialMonth]);

	const handleApply = () => {
		onApply(selectedMonth);
		onClose();
	};

	const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.target === e.currentTarget) {
			onClose();
		}
	};

	if (!isOpen) return null;

	return (
		<div className={styles.backdrop} onClick={handleBackdropClick}>
			<div className={styles.modal}>
				<div className={styles.header}>
					<h2 className={styles.title}>Select Month</h2>
					<button className={styles.closeButton} onClick={onClose}>
						×
					</button>
				</div>

				<div className={styles.content}>
					<div className={styles.monthGrid}>
						{monthOptions.map((option) => (
							<button
								key={option.value}
								className={`${styles.monthButton} ${
									selectedMonth === option.value ? styles.active : ""
								}`}
								onClick={() => setSelectedMonth(option.value)}
							>
								{option.label}
							</button>
						))}
					</div>
				</div>

				<div className={styles.actions}>
					<Button text="Cancel" variant="secondary" onClick={onClose} />
					<Button text="Apply" variant="primary" onClick={handleApply} />
				</div>
			</div>
		</div>
	);
};
